// Code generated by backend/cmd/gen-error-codes. DO NOT EDIT.
// Regenerate with: make gen   (cd backend && go run ./cmd/gen-error-codes ...)
//
// ADR-028 / PR-H2 — backend ErrorCatalog mirrored as TypeScript types.
// Frontend interceptor (PR-H3) and page handlers should import ErrorCode
// + ERROR_METADATA here instead of hardcoding string literals.
//
// Generated at: 2026-09-29T01:52:40Z

export type FrontendBehavior =
  | "showSnackbar"
  | "skipGlobalSnackbar";

export type ErrorCode =
  | "ALERT_EVENT_INVALID"
  | "FILE_CORRUPTED"
  | "FILE_DELETED"
  | "FILE_DUPLICATE"
  | "FILE_EMPTY"
  | "FILE_NAME_CONFLICT"
  | "FILE_NOT_FOUND"
  | "FILE_TYPE_NOT_ALLOWED"
  | "GROUP_DELETE_REQUIRES_DESTINATION"
  | "INTERNAL_ERROR"
  | "INVALID_INPUT"
  | "INVALID_STATUS"
  | "LAST_GROUP_REQUIRES_DESTINATION"
  | "OPERATION_FAILED"
  | "SELF_DELETE"
  | "SESSION_EXPIRED"
  | "SESSION_IDLE_TIMEOUT"
  | "SESSION_REVOKED"
  | "SMTP_NOT_CONFIGURED"
  | "SMTP_UNAVAILABLE"
  | "TOKEN_REVOKED"
  | "UNAUTHORIZED"
  | "UPLOAD_FAILED"
  | "UPLOAD_SESSION_NOT_FOUND"
  | "USER_HAS_RESOURCES"
  | "USER_STILL_ACTIVE"
  | "VALIDATION_ERROR"
  | "VAULT_UNAVAILABLE"
  | "WORKER_UNAVAILABLE";

export interface ErrorMetadata {
  code: ErrorCode;
  httpStatus: number;
  defaultMessage: string;
  retryable: boolean;
  userVisible: boolean;
  frontendBehavior: FrontendBehavior;
}

export const ERROR_METADATA: Record<ErrorCode, ErrorMetadata> = {
  "ALERT_EVENT_INVALID": {
    code: "ALERT_EVENT_INVALID",
    httpStatus: 400,
    defaultMessage: "告警事件不在支援的清單內",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_CORRUPTED": {
    code: "FILE_CORRUPTED",
    httpStatus: 422,
    defaultMessage: "雲端資料損壞，請重新備份此檔案",
    retryable: false,
    userVisible: true,
    frontendBehavior: "skipGlobalSnackbar",
  },
  "FILE_DELETED": {
    code: "FILE_DELETED",
    httpStatus: 400,
    defaultMessage: "file already deleted",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_DUPLICATE": {
    code: "FILE_DUPLICATE",
    httpStatus: 409,
    defaultMessage: "此檔案已存在，無需重複上傳",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_EMPTY": {
    code: "FILE_EMPTY",
    httpStatus: 400,
    defaultMessage: "空檔案（0 byte）不備份",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_NAME_CONFLICT": {
    code: "FILE_NAME_CONFLICT",
    httpStatus: 409,
    defaultMessage: "已存在同名檔案但內容不同，請重新命名後再上傳",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_NOT_FOUND": {
    code: "FILE_NOT_FOUND",
    httpStatus: 404,
    defaultMessage: "file not found",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "FILE_TYPE_NOT_ALLOWED": {
    code: "FILE_TYPE_NOT_ALLOWED",
    httpStatus: 400,
    defaultMessage: "此檔案類型不允許上傳",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "GROUP_DELETE_REQUIRES_DESTINATION": {
    code: "GROUP_DELETE_REQUIRES_DESTINATION",
    httpStatus: 409,
    defaultMessage: "群組內仍有備份資源或已停用成員，請指定要轉移到的群組",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "INTERNAL_ERROR": {
    code: "INTERNAL_ERROR",
    httpStatus: 500,
    defaultMessage: "internal error",
    retryable: true,
    userVisible: false,
    frontendBehavior: "showSnackbar",
  },
  "INVALID_INPUT": {
    code: "INVALID_INPUT",
    httpStatus: 400,
    defaultMessage: "輸入資料有誤，請檢查必填欄位與格式",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "INVALID_STATUS": {
    code: "INVALID_STATUS",
    httpStatus: 400,
    defaultMessage: "invalid file status",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "LAST_GROUP_REQUIRES_DESTINATION": {
    code: "LAST_GROUP_REQUIRES_DESTINATION",
    httpStatus: 409,
    defaultMessage: "這是該使用者的最後一個群組，請指定去向群組",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "OPERATION_FAILED": {
    code: "OPERATION_FAILED",
    httpStatus: 500,
    defaultMessage: "operation failed",
    retryable: true,
    userVisible: false,
    frontendBehavior: "showSnackbar",
  },
  "SELF_DELETE": {
    code: "SELF_DELETE",
    httpStatus: 400,
    defaultMessage: "不能刪除自己的帳號",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "SESSION_EXPIRED": {
    code: "SESSION_EXPIRED",
    httpStatus: 401,
    defaultMessage: "登入已超過 24 小時上限，請重新登入",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "SESSION_IDLE_TIMEOUT": {
    code: "SESSION_IDLE_TIMEOUT",
    httpStatus: 401,
    defaultMessage: "閒置超過 30 分鐘，請重新登入",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "SESSION_REVOKED": {
    code: "SESSION_REVOKED",
    httpStatus: 401,
    defaultMessage: "此帳號已在其他裝置登入或已登出，請重新登入",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "SMTP_NOT_CONFIGURED": {
    code: "SMTP_NOT_CONFIGURED",
    httpStatus: 400,
    defaultMessage: "尚未設定郵件伺服器（SMTP），請聯絡管理員確認部署環境的寄信設定",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "SMTP_UNAVAILABLE": {
    code: "SMTP_UNAVAILABLE",
    httpStatus: 503,
    defaultMessage: "郵件服務目前無法使用，無法寄送驗證碼，請聯絡管理員",
    retryable: true,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "TOKEN_REVOKED": {
    code: "TOKEN_REVOKED",
    httpStatus: 401,
    defaultMessage: "登入狀態已失效，請重新登入",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "UNAUTHORIZED": {
    code: "UNAUTHORIZED",
    httpStatus: 403,
    defaultMessage: "unauthorized access to file",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "UPLOAD_FAILED": {
    code: "UPLOAD_FAILED",
    httpStatus: 502,
    defaultMessage: "檔案備份失敗，請稍後再試",
    retryable: true,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "UPLOAD_SESSION_NOT_FOUND": {
    code: "UPLOAD_SESSION_NOT_FOUND",
    httpStatus: 404,
    defaultMessage: "沒有進行中的上傳可取消",
    retryable: false,
    userVisible: true,
    frontendBehavior: "skipGlobalSnackbar",
  },
  "USER_HAS_RESOURCES": {
    code: "USER_HAS_RESOURCES",
    httpStatus: 409,
    defaultMessage: "這個帳號仍擁有備份檔案、File Watcher、目的地或排程，無法永久刪除",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "USER_STILL_ACTIVE": {
    code: "USER_STILL_ACTIVE",
    httpStatus: 409,
    defaultMessage: "請先停用這個帳號，再永久刪除",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "VALIDATION_ERROR": {
    code: "VALIDATION_ERROR",
    httpStatus: 400,
    defaultMessage: "輸入資料有誤，請檢查標示的欄位",
    retryable: false,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "VAULT_UNAVAILABLE": {
    code: "VAULT_UNAVAILABLE",
    httpStatus: 503,
    defaultMessage: "加密服務暫時無法使用，請稍後再試",
    retryable: true,
    userVisible: true,
    frontendBehavior: "showSnackbar",
  },
  "WORKER_UNAVAILABLE": {
    code: "WORKER_UNAVAILABLE",
    httpStatus: 503,
    defaultMessage: "備份服務暫時無法使用，請稍後重試",
    retryable: true,
    userVisible: true,
    frontendBehavior: "skipGlobalSnackbar",
  },
};

/**
 * Returns the catalog entry for a code, or undefined if the code is not in the
 * taxonomy. Use this to safely handle codes from API responses.
 */
export function metadataFor(code: string | undefined | null): ErrorMetadata | undefined {
  if (!code) return undefined;
  return ERROR_METADATA[code as ErrorCode];
}
